import { Controller }  from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['childrenContainer', 'root']

  connect() {
    this.syncCategories()
  }

  enable (elements) {
    elements.forEach(el => el.disabled = false)
  }

  disable (elements) {
    elements.forEach(el => el.disabled = true)
  }

  syncCategories () {
    const checkedRoot = this.rootTargets.find(r => r.checked)

    this.rootTargets.forEach(root => {
      const isActive = checkedRoot && root === checkedRoot

      const container = this.childrenContainerTargets.find(
        c => c.dataset.rootId === root.dataset.rootId
      )

      const children = container?.querySelectorAll('input[type="checkbox"]') || []

      if (checkedRoot) {
        // lock other roots
        root.disabled = !isActive

        if (isActive) {
          this.enable(children)
        } else {
          this.disable(children)
          children.forEach(c => (c.checked = false))
        }
      } else {
        // enable all roots when none are selected
        root.disabled = false
        this.disable(children)
        children.forEach(c => (c.checked = false))
      }
    })
  }

  toggleRoot (event) {
    const clickedRoot = event.target

    this.rootTargets.forEach(root => {
      root.checked = root === clickedRoot ? root.checked : false
    })

    this.syncCategories()
  }
}
